import API from 'services/TAPS_API/index';
import { moment } from 'utils';

export default function get3NDFLMessage(notificationId) {
  return API.request({
    method: 'GET',
    url: `/need-to-provide3-ndfl/data`,
    params: {
      notificationId,
    },
    mapper: function (data) {
      return {
        date:
          data.notificationDate && moment(data.notificationDate).isValid()
            ? moment(data.notificationDate)
            : null,
        reason: data.notificationReason || null,
        object: data.notificationReasonDescriptionO || null,
        objects: data.notificationReasonDescriptionsO || null,
        legalEntities: data.notificationReasonDescriptionsD || null,
        notificationUntil: data.notificationUntil || null,
        notificationYear: data.notificationYear || null,
        partInCapital: data.notificationReasonDescriptionY || null,
        taxAgent: data.notificationReasonDescriptionA || null,
        documentNumber: data.notificationDocNum || null,
        taxAuthority: {
          code: data.taxAuthorityCode,
          name: data.taxAuthorityName,
        },
        isActive: data.isActive,
      };
    },
  });
}
